import { render, staticRenderFns } from "./LeagueTable.vue?vue&type=template&id=4b745554&scoped=true&"
import script from "./LeagueTable.vue?vue&type=script&lang=js&"
export * from "./LeagueTable.vue?vue&type=script&lang=js&"
import style0 from "./LeagueTable.vue?vue&type=style&index=0&id=4b745554&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b745554",
  null
  
)

export default component.exports